import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

export default function SelectedAccounttypesReducer(state = initialState.selectedAccounttypes, action: any) {
  switch (action.type) {
    case types.SAVE_SELECTED_ACCOUNTTYPES_SUCCESS:
      return action.selectedAccounttypes;
    default:
      return state;
  }
}
